import React from 'react'

import { Dropdown, useResponsiveDropdown } from '@sketch/components'

import {
  useHideAnnotationDots,
  useIsAnnotationContextAvailable,
} from 'modules/annotations/hooks'

import { DotsIcon, SettingsButton } from './DetailSettingsDropdown.styles'

const HIDE_ANNOTATION_DOTS_COPY = {
  false: 'Hide Comments',
  true: 'Show Comments',
} as const

const DetailDropdown = () => {
  const [hideAnnotations, setHideAnnotations] = useHideAnnotationDots() || []

  return (
    <>
      <Dropdown.Header>Artboard</Dropdown.Header>
      {hideAnnotations !== undefined && (
        <Dropdown.Item onClick={() => setHideAnnotations?.(!hideAnnotations)}>
          {HIDE_ANNOTATION_DOTS_COPY[`${hideAnnotations}` as const]}
          <Dropdown.Item.ShortcutText>Shift N</Dropdown.Item.ShortcutText>
        </Dropdown.Item>
      )}
    </>
  )
}

export const DetailSettingsDropdown = () => {
  const isAnnotationContextAvailable = useIsAnnotationContextAvailable()

  const [dropdown, buttonProps] = useResponsiveDropdown({
    dropdown: DetailDropdown,
    placement: 'bottom-end',
  })

  if (!isAnnotationContextAvailable) {
    return null
  }

  return (
    <>
      <SettingsButton data-testid="artboard-settings-toggle" {...buttonProps}>
        <DotsIcon />
        <span className="sr-only">Artboard Settings</span>
      </SettingsButton>
      {dropdown}
    </>
  )
}

export default DetailSettingsDropdown
